export default "__VITE_ASSET__Dbxr6WqU__"